import { useFormik } from "formik";
import { Button, Grid2, Stack, Typography } from "@mui/material";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import background from "../assets/png/login-background.png";
import LoginImage from "../assets/png/loginImg.png";
import Logo from "../assets/svg/logo.svg";
import LogoFull from "../assets/svg/logo-full.svg";
import { Input } from "../components/Input";
import { useEffect, useState } from "react";
import { Circle } from "@mui/icons-material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { phoneValidator, storeRegister } from "../services/store";
import { checkCep } from "../services/app";
import {
  cpfCnpjValidator,
  formatCpfCnpj,
  formatPhone,
  unMask,
} from "../helpers/format";
import ContainerLoadingLogin from "../components/ContainerLoadingLogin";
import moment from "moment";
import { validateToken } from "../services/auth";
import { useUserStore } from "../stores/user";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const navigate = useNavigate();
  const { setUser } = useUserStore();
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");

  const { mutate: mutatePhoneValidator, isPending: isPendingPhoneValidator } =
    useMutation({
      mutationFn: phoneValidator,
      onSuccess: () => {
        setStep(step + 1);
      },
      onError: (e: { response: { data: { message: string } } }) => {
        toast.error(String(e?.response?.data?.message) || "Erro!");
      },
    });

  const { mutate: mutateToken, isPending: isPendingToken } = useMutation({
    mutationFn: validateToken,
    onSuccess: () => {
      setStep(step + 1);
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate, isPending } = useMutation({
    mutationFn: storeRegister,
    onSuccess: (e: any) => {
      toast.success("Usuário Cadastrado!");
      localStorage.setItem("access_token", e.access_token);
      setUser(e);
      navigate("/dashboard");
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { refetch, data, isFetching } = useQuery({
    queryFn: async () => await checkCep(values.cep),
    queryKey: ["getCep"],
    enabled: false,
  });

  const { handleChange, values, handleSubmit, setFieldValue } = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      document: "",
      birthDate: "",
      password: "",
      confirm: "",
      cardNumber: "",
      expireDate: "",
      cvv: "",
      cardName: "",
      state: "",
      city: "",
      neighborhood: "",
      street: "",
      number: "",
      complement: "",
      cep: "",
      documentUser: "",
      userName: "",
    },
    onSubmit: (values: any) => {
      mutate({
        ...values,
        documentUser: unMask(values.documentUser),
        phone: unMask(values.phone),
        document: unMask(values.document),
        birthDate: moment(values.birthDate).toDate(),
      });
    },
  });

  useEffect(() => {
    if (data) {
      setFieldValue("neighborhood", data?.neighborhood);
      setFieldValue("state", data?.state);
      setFieldValue("street", data?.address);
      setFieldValue("city", data?.city);
    }
  }, [data]);

  return (
    <ContainerLoadingLogin
      loading={
        isPending || isFetching || isPendingPhoneValidator || isPendingToken
      }
    >
      <Grid2 container>
        <Grid2
          size={{ md: 6 }}
          display={{ xs: "none", md: "grid" }}
          sx={{
            background: `url(${LoginImage})`,
            backgroundSize: "cover",
          }}
        >
          <Grid2 container spacing={2} sx={{ height: "100vh" }}>
            <Grid2 size={12} sx={{ padding: 4 }}>
              <img src={Logo} alt="logo" />
            </Grid2>
            <Grid2 size={12} sx={{ padding: 4 }}>
              <Stack sx={{ height: "100%", justifyContent: "center" }}>
                <Typography variant="h4" fontWeight={700}>
                  Descubra uma nova forma de interação com sua academia
                </Typography>
              </Stack>
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2
          size={{ md: 6 }}
          sx={{
            background: `url(${background})`,
          }}
        >
          <Stack
            sx={{
              width: "100%",
              height: "100vh",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid2 container spacing={2} sx={styles.paper}>
              <Grid2 size={12}>
                <img
                  src={LogoFull}
                  alt="logo-full"
                  onClick={() => setStep(1)}
                />
              </Grid2>
              <Grid2 size={12}>
                <Stack
                  sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Stack sx={{ flexDirection: "row", gap: 0.5, mt: 2, mb: 2 }}>
                    <Circle
                      sx={{
                        color: step === 1 ? "primary.main" : "primary.light",
                        fontSize: 8,
                      }}
                    />
                    <Circle
                      sx={{
                        color: step === 2 ? "primary.main" : "primary.light",
                        fontSize: 8,
                      }}
                    />
                    <Circle
                      sx={{
                        color: step === 3 ? "primary.main" : "primary.light",
                        fontSize: 8,
                      }}
                    />
                    <Circle
                      sx={{
                        color: step === 4 ? "primary.main" : "primary.light",
                        fontSize: 8,
                      }}
                    />
                    <Circle
                      sx={{
                        color: step === 5 ? "primary.main" : "primary.light",
                        fontSize: 8,
                      }}
                    />
                  </Stack>
                </Stack>
                <Typography variant="h5" fontWeight={700}>
                  Boas vindas ao Fight GO
                </Typography>
                <Typography>
                  {step === 5
                    ? "Selecione o seu plano (Opcional)"
                    : "Informe seus dados para criar sua conta."}
                </Typography>
              </Grid2>
              {step === 1 && (
                <Grid2 size={12} mt={2}>
                  <Grid2 container size={12} spacing={2}>
                    <Grid2 size={12}>
                      <Input
                        id="userName"
                        name="userName"
                        label="Seu nome completo"
                        type="text"
                        fullWidth
                        value={values.userName}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={6}>
                      <Input
                        id="documentUser"
                        name="documentUser"
                        label="Seu CPF"
                        type="text"
                        fullWidth
                        value={formatCpfCnpj(values.documentUser)}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={6}>
                      <Input
                        id="phone"
                        name="phone"
                        label="Seu telefone"
                        type="tel"
                        fullWidth
                        value={formatPhone(values.phone)}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={12}>
                      <Input
                        id="birthDate"
                        name="birthDate"
                        label="Sua data de nascimento"
                        type="date"
                        fullWidth
                        value={values.birthDate}
                        onChange={handleChange}
                        onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                          e.target.showPicker()
                        }
                      />
                    </Grid2>
                  </Grid2>
                </Grid2>
              )}
              {step === 2 && (
                <Grid2 size={12} mt={2}>
                  <Stack spacing={4} alignItems="center">
                    <Typography fontWeight={700}>
                      Enviamos um token de confirmação para seu telefone
                    </Typography>
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={5}
                      renderInput={(props) => <input {...props} />}
                      containerStyle={{ gap: 10 }}
                      inputStyle={{
                        height: "60px",
                        width: "50px",
                        fontSize: "32px",
                        fontWeight: 600,
                        color: "primary.contrastText",
                        backgroundColor: "secondary.light",
                        borderRadius: "10px",
                        borderStyle: "solid",
                        borderColor: "secondary.contrastext",
                      }}
                    />
                  </Stack>
                </Grid2>
              )}

              {step === 3 && (
                <Grid2 size={12} mt={2}>
                  <Grid2 container size={12} spacing={2}>
                    <Grid2 size={12}>
                      <Input
                        id="name"
                        name="name"
                        label="Nome da academia"
                        type="text"
                        fullWidth
                        value={values.name}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={12}>
                      <Input
                        id="document"
                        name="document"
                        label="CNPJ/CPF da academia"
                        type="text"
                        fullWidth
                        value={formatCpfCnpj(values.document)}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={12}>
                      <Input
                        id="email"
                        name="email"
                        label="Seu e-mail"
                        type="email"
                        fullWidth
                        value={values.email}
                        onChange={handleChange}
                      />
                    </Grid2>
                  </Grid2>
                </Grid2>
              )}
              {step === 4 && (
                <Grid2 size={12} mt={2}>
                  <Grid2 container size={12} spacing={2}>
                    <Grid2 size={8}>
                      <Input
                        id="cep"
                        name="cep"
                        label="CEP"
                        type="text"
                        fullWidth
                        value={values.cep}
                        onChange={handleChange}
                        onBlur={() => {
                          refetch();
                        }}
                      />
                    </Grid2>

                    <Grid2 size={4}>
                      <Input
                        id="number"
                        name="number"
                        label="Número"
                        type="text"
                        fullWidth
                        value={values.number}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={6}>
                      <Input
                        id="street"
                        name="street"
                        label="Rua"
                        type="text"
                        fullWidth
                        value={values.street}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={6}>
                      <Input
                        id="neighborhood"
                        name="neighborhood"
                        label="Bairro"
                        type="text"
                        fullWidth
                        value={values.neighborhood}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={8}>
                      <Input
                        id="city"
                        name="city"
                        label="Cidade"
                        type="text"
                        fullWidth
                        value={values.city}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={4}>
                      <Input
                        id="state"
                        name="state"
                        label="Estado"
                        type="text"
                        fullWidth
                        value={values.state}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={12}>
                      <Input
                        id="complement"
                        name="complement"
                        label="Complemento"
                        type="text"
                        fullWidth
                        value={values.complement}
                        onChange={handleChange}
                      />
                    </Grid2>
                  </Grid2>
                </Grid2>
              )}
              {step === 5 && (
                <Grid2 size={12} mt={2}>
                  <Grid2 container size={12} spacing={1}>
                    <Grid2 size={12}>
                      <Input
                        id="password"
                        name="password"
                        label="Senha"
                        type="password"
                        fullWidth
                        value={values.password}
                        onChange={handleChange}
                      />
                    </Grid2>
                    <Grid2 size={12}>
                      <Input
                        id="confirm"
                        name="confirm"
                        label="Confirme a senha"
                        type="password"
                        fullWidth
                        value={values.confirm}
                        onChange={handleChange}
                      />
                    </Grid2>
                  </Grid2>
                </Grid2>
              )}
              <Grid2 size={12} mt={2}>
                <Stack spacing={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={() => {
                      if (step === 1) {
                        if (!values.userName) {
                          toast.error("Digite seu nome");
                          return;
                        }
                        if (!cpfCnpjValidator(values.documentUser)) {
                          toast.error("Digite seu CPF");
                          return;
                        }
                        if (!values.phone) {
                          toast.error("Digite seu telefone");
                          return;
                        }

                        if (!values.birthDate) {
                          toast.error("Digite sua data de nascimento");
                          return;
                        }
                        mutatePhoneValidator({
                          phone: unMask(values.phone),
                        });
                      }

                      if (step === 2) {
                        if (!otp) {
                          toast.error("Digite o token!");
                          return;
                        }
                        mutateToken({
                          token: otp,
                        });
                      }

                      if (step === 3) {
                        if (!values.name) {
                          toast.error("Digite o nome da academia");
                          return;
                        }
                        if (!cpfCnpjValidator(values.document)) {
                          toast.error("Digite o CPF/CNPJ da academia");
                          return;
                        }
                        if (!values.email) {
                          toast.error("Digite o e-mail");
                          return;
                        }

                        setStep(step + 1);
                      }

                      if (step === 4) {
                        if (!values.cep) {
                          toast.error("Digite o CEP");
                          return;
                        }
                        if (!values.street) {
                          toast.error("Digite a rua");
                          return;
                        }
                        if (!values.neighborhood) {
                          toast.error("Digite o bairro");
                          return;
                        }
                        if (!values.number) {
                          toast.error("Digite o número");
                          return;
                        }
                        if (!values.city) {
                          toast.error("Digite a cidade");
                          return;
                        }
                        if (!values.state) {
                          toast.error("Digite o estado");
                          return;
                        }

                        setStep(step + 1);
                      }

                      if (step === 5) {
                        if (!values.password) {
                          toast.error("Digite sua senha");
                          return;
                        }
                        if (!values.confirm) {
                          toast.error("Confirme sua senha");
                          return;
                        }

                        if (values.password !== values.confirm) {
                          toast.error("Senhas não conferem");
                          return;
                        }

                        handleSubmit();
                      }
                    }}
                  >
                    {step === 6 ? "Finalizar" : "Continuar"}
                  </Button>
                  {step > 1 && (
                    <Button variant="text" onClick={() => setStep(step - 1)}>
                      Voltar
                    </Button>
                  )}
                  <Button
                    variant="text"
                    onClick={() => navigate("/")}
                    sx={{ color: "primary.contrastText" }}
                  >
                    Já tem seu cadastro? Faça login aqui
                  </Button>
                </Stack>
              </Grid2>
            </Grid2>
          </Stack>
        </Grid2>
      </Grid2>
    </ContainerLoadingLogin>
  );
};

const styles = {
  paper: {
    width: { md: "70%" },
    backgroundColor: "background.default",
    padding: "2rem",
    borderRadius: "24px",
  },
  avatar: {
    backgroundColor: "blueviolet",
  },
};

export default SignUp;
